import { useLocation } from 'react-router-dom';
import {
    useExportarPeriodicosMutation,
    useGetEmployeesConvocatedQuery
} from '../../../services/periodicosApi';
import useGlobalFilters from '../../../hooks/useGlobalFilters';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useAppDispatch } from '../../../hooks/reduxHooks';
import { showAlert } from '../../../features/slices/applicationSlice';
import { ALERT_CONFIRM_TEXT, ERROR_CONTACT_SUPPORT } from '../../../constants/values';

export const useConvocados = () => {
    const location = useLocation();
    const { idConvocatoria, cuit, nombreOrganismoCentral } = location.state || {};
    const { enqueueSnackbar } = useSnackbar();
    const [exportarPeriodicos] = useExportarPeriodicosMutation();
    const dispatch = useAppDispatch();
    const { t } = useTranslation('periodicos');
    const [isExporting, setIsExporting] = useState(false);
    const {
        filters,
        setFilters,
        extraFilters,
        setExtraFilters,
        handleChangeExtraFilters,
        handleSubmitSearch,
        clearFilters
    } = useGlobalFilters();

    const handleExportarExcel = async () => {
        setIsExporting(true);
        try {
            const response = await exportarPeriodicos({ ...filters, idConvocatoria }).unwrap();

            const byteArray = new Uint8Array(response.data);
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte-Convocados.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();

            enqueueSnackbar(t('alerts.exportExcel.generateSuccess'), { variant: 'success' });
        } catch (error: any) {
            dispatch(
                showAlert({
                    title: 'No se pudo exportar el Excel de convocados',
                    message: error?.data?.message || ERROR_CONTACT_SUPPORT,
                    icon: 'error',
                    confirmText: ALERT_CONFIRM_TEXT
                })
            );
        } finally {
            setIsExporting(false);
        }
    };

    const { data, isFetching, refetch } = useGetEmployeesConvocatedQuery(
        { ...filters, idConvocatoria },
        { skip: !idConvocatoria }
    );

    return {
        convocatedData: data,
        isFetching,
        filters,
        setFilters,
        extraFilters,
        handleChangeExtraFilters,
        handleSubmitSearch,
        clearFilters,
        idConvocatoria,
        refetch,
        handleExportarExcel,
        isExporting,
        nombreOrganismoCentral,
        cuit
    };
};
